//
// GENERATED by KVision
//
package pl.finn.forms.swz

import io.kvision.remote.HttpMethod
import io.kvision.remote.KVServiceManager
import io.kvision.remote.registerKVisionServiceExceptions

expect class SwzService : ISwzService

object SwzServiceManager : KVServiceManager<SwzService>(SwzService::class) {
    init {
        registerKVisionServiceExceptions()
        bind(ISwzService::nowy, HttpMethod.POST, null)
        bind(ISwzService::edycja, HttpMethod.POST, null)
        bind(ISwzService::sprawdz, HttpMethod.POST, null)
        bind(ISwzService::zapisz, HttpMethod.POST, null)
        bind(ISwzService::podglad, HttpMethod.POST, null)
    }
}
